import { render, staticRenderFns } from "./proyeksi_spklu.vue?vue&type=template&id=136beaa4&scoped=true&"
import script from "./proyeksi_spklu.vue?vue&type=script&lang=js&"
export * from "./proyeksi_spklu.vue?vue&type=script&lang=js&"
import style0 from "./proyeksi_spklu.vue?vue&type=style&index=0&id=136beaa4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136beaa4",
  null
  
)

export default component.exports